module.exports = __webpack_public_path__ + "img/Hc.5f13b1bc.png";